import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ArrowRight } from "@phosphor-icons/react";

export default function ResultsListPage() {
    const [results, setResults] = useState([]);
    useEffect(() => { api.get("/results").then(r => setResults(r.data)); }, []);

    return (
        <div className="min-h-screen" data-testid="results-list-page">
            <Navbar />
            <section className="mx-auto max-w-6xl px-6 py-14">
                <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Transcript</div>
                <h1 className="font-serif text-5xl text-ink">Your test results</h1>
                <div className="mt-10 border border-ink/15 rounded-sm bg-bone divide-y divide-ink/10">
                    {results.length === 0 && <div className="p-10 text-center text-ink/50" data-testid="empty-transcript">Your transcript will appear here after your first attempt.</div>}
                    {results.map(r => (
                        <Link key={r.id} to={`/results/${r.id}`} data-testid={`row-${r.id}`} className="flex items-center justify-between p-5 hover:bg-parchment/60 transition-colors">
                            <div>
                                <div className="font-serif text-lg text-ink">{r.course_name}</div>
                                <div className="text-xs uppercase tracking-widest text-ink/50">{r.test_type} · {new Date(r.created_at).toLocaleString()}</div>
                            </div>
                            <div className="flex items-center gap-6">
                                <div className="text-right">
                                    <div className={`font-serif text-xl ${r.percent >= 75 ? "text-emerald-800" : r.percent >= 50 ? "text-gold-dark" : "text-oxblood"}`}>{r.percent}%</div>
                                    <div className="text-[10px] uppercase tracking-widest text-ink/50">{r.score}/{r.total}</div>
                                </div>
                                <ArrowRight size={16} className="text-ink/40"/>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
            <Footer />
        </div>
    );
}
